import folderStore from 'owa-folders';
import { setStaticSearchScope } from 'owa-mail-search';
import { getStore as getMailSearchStore } from 'owa-mail-search';
import { lazyIsSearchBoxEmpty, SearchScenarioId, startSearch } from 'owa-search';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./FolderTag.scss');

export interface FolderTagProps {
    folderId: string; // The ID of the folder being represented
    isPreviewTextOn: boolean; // If preview text is displayed in the list view
    isSingleLine: boolean; // If tag is being displayed in SLV
    isUnread: boolean; // If tag is part of a mail item that is unread
}

export default class FolderTag extends React.Component<FolderTagProps, {}> {
    render() {
        const { folderId, isPreviewTextOn, isSingleLine, isUnread } = this.props;
        const folder = folderStore.folderTable.get(folderId);

        // We found out that search can sometimes return an item from a folder that does
        // not exist in the folder table. If that is the case we do not want to render
        // the folder tag.
        // VSO: 26898 - Search returns an item from a folder that does not exist in store
        if (!folder) {
            return null;
        }

        /**
         * Determine the color of the tag based on if underlying mail item is
         * unread or not.
         */
        const colorClassName = isUnread ? styles.unreadItemFolderTag : styles.readItemFolderTag;

        /**
         * Determine styles on the outer container based on if user is in SLV
         * or not.
         */
        const containerClassName = isSingleLine
            ? styles.folderTagContainer
            : styles.folderTagContainerThreeColumn;

        /**
         * Give container a right margin if the user is in 3 column view and has
         * preview text off. In this scenario, the folder tag will flow with
         * categories (if present) in a single line.
         */
        const rightMarginClassName =
            !isSingleLine && !isPreviewTextOn ? styles.folderTagContainerRightMargin : '';

        /**
         * Give container a left margin if the user is in 3 column view and has preview
         * text on or if user is in SLV.
         */
        const leftMarginClassName =
            (!isSingleLine && isPreviewTextOn) || isSingleLine
                ? styles.folderTagContainerLeftMargin
                : '';

        // Concatenate styles for container.
        const folderTagContainerClassNames = classNames([
            colorClassName,
            containerClassName,
            rightMarginClassName,
            leftMarginClassName,
            this.checkSearchBoxEmpty() && styles.unclickableFolderTag,
        ]);

        return (
            <button className={folderTagContainerClassNames} onClick={this.onFolderTagClick}>
                <span className={styles.folderTagLabel}>{folder.DisplayName}</span>
            </button>
        );
    }

    private checkSearchBoxEmpty(): boolean {
        const isSearchBoxEmpty = lazyIsSearchBoxEmpty.tryImportSync();
        return isSearchBoxEmpty && isSearchBoxEmpty(SearchScenarioId.Mail);
    }

    private onFolderTagClick = async (ev: React.MouseEvent<EventTarget>) => {
        // Stop click so it doesn't get acted on by MailListItem.
        ev.stopPropagation();

        /**
         * If user cleared search box between search and clicking folder
         * tag, it's a no-op.
         */

        if (this.checkSearchBoxEmpty()) {
            return;
        }

        // Create new search scope to match folder represented by folder tag.
        let searchScope = null;
        searchScope = {
            kind: getMailSearchStore().staticSearchScope.kind,
            folderId: this.props.folderId,
        };

        // Change search scope to match the selected folder tag.
        setStaticSearchScope(searchScope);

        // Start search.
        startSearch('FolderTag', SearchScenarioId.Mail, false /* explicitSearch */);
    };
}
